export default {
  supplier: [],
  supplierArchived: [],
  dealers: [],
  dealersArchived: [],
  pagination: null,
  params: {
    page: '1',
    per_page: '25',
    query: null,
    statuses: null,
    dealer: null,
    date_from: null,
    date_to: null,
  },
  statuses: [],
  reclamation: null,
  search: null,
}
